const module = {
  config: {
    name: 'pengaturan-forum',
    icon: 'ri-wechat-line',
    desc: '',
    group: 'Forum',
    layout: true
  },
  routes: [
    { name: 'forum-categories', label: 'Kategori Forum', icon: 'ri-file-text-line', path: '/forum-categories', component: () => import('./forum-categories.vue') },
    { name: 'news-categories', label: 'Kategori Berita', icon: 'ri-file-text-line', path: '/news-categories', component: () => import('./news-categories.vue') },
    { name: 'feedback-categories', label: 'Kategori Kritik & Saran', icon: 'ri-file-text-line', path: '/feedback-categories', component: () => import('./feedback-categories.vue') },
    { name: 'gallery-categories', label: 'Kategori Gallery', icon: 'ri-file-text-line', path: '/gallery-categories', component: () => import('./gallery-categories.vue') }
    // { name: 'structural-components', label: 'Kategori Pengurus', icon: 'ri-file-text-line', path: '/structural-components', component: () => import('./structural-components.vue') }
    // { name: 'news', label: 'Berita', icon: 'ri-skip-right-fill', path: '/news', component: () => import('./users.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/master-data/_index.js